<div class="icon-container">
    <svg-icon [icon]="iconClass" [class]="iconStyle"></svg-icon>
</div>